module.exports = __webpack_public_path__ + "img/singlecover.fc88dafb.svg";